'use strict';

import React from 'react';
import { Link } from 'react-router';
import flux from 'utils/flux';
import dom from 'utils/dom';
import diff from 'object-diff';
import merge from 'lodash/object/merge';
import { removeFromPipedQuery } from 'utils/strings';
import _ from 'lodash';

var MediaSelectedFilters = React.createClass({

    displayName: 'MediaSelectedFilters',

    mixins: [],

    propTypes: {
        filters: React.PropTypes.object,
        size: React.PropTypes.number
    },

    contextTypes: {
        router: React.PropTypes.func.isRequired
    },

    removeFilter(index, e) {
        e.preventDefault();

        if ( dom.hasClass( e.target, 'filter__remove' ) ) {
            flux.getActions('media').removeSelectedFilter( index );
        }
    },

    render() {
        if (this.props.filters.size === 0 || this.props.size === 0) {
            return false;
        }
        let filters = _.uniq(this.props.filters.toJS(), 'name');
        var query = this.props.query;
        return (
            <div className="media__selectedfilters">
                {filters.map( (sfilter, i) => {
                    sfilter.params && sfilter.params.page && delete sfilter.params.page;

                    var filterQuery     = removeFromPipedQuery( sfilter.params, query, true );
                    var filterQueryKeys = Object.keys( sfilter.params );
                    var isChildFilter   = filterQueryKeys.length > 1;
                    var firstQueryKey   = filterQueryKeys[0];

                    if ( !isChildFilter ) {
                        filterQuery = diff( sfilter.params, filterQuery );
                        var childFilters = filters.filter( rfilter => {
                            return (
                                rfilter !== sfilter &&
                                typeof rfilter.params[firstQueryKey] !== 'undefined' &&
                                rfilter.params[firstQueryKey] === sfilter.params[firstQueryKey]
                            )
                        });
                        childFilters.forEach( cfilter => {
                            filterQuery = removeFromPipedQuery( cfilter.params, filterQuery, true )
                            filterQuery = diff( cfilter.params, filterQuery );
                        });
                    }
                    else {
                        var parentFilter = filters.filter( rfilter => {
                            var queryKeys = Object.keys( rfilter.params );
                            return( rfilter !== sfilter && queryKeys.length <= 1 && queryKeys[0] === firstQueryKey )
                        }).shift();
                        parentFilter = parentFilter || {};
                        filterQuery = merge( diff( sfilter.params, filterQuery ), parentFilter.params );
                    }

                    if ( 1 === Object.keys( filterQuery ).length && filterQuery.page ) {
                        delete filterQuery.page;
                    }

                    if ( 1 === Object.keys( filterQuery ).length && filterQuery.per_page ) {
                        delete filterQuery.per_page;
                    }

                    return (
                        <Link to="listing" key={'filter_selected_'+i} query={filterQuery} className="btn btn-primary btn-small">
                            {sfilter.name}
                            <span className="filter__remove" />
                        </Link>
                    );
                })}
            </div>
        );
    }
});

module.exports = MediaSelectedFilters;



// WEBPACK FOOTER //
// ./app/pages/media/mediaSelectedFilters.jsx